<template>
  <span class="group-name-tags" v-if="selectedNames">
    <span v-for="(name, index) in selectedNames"
          :key="index"
          class="selected-tag">
      {{name}}
      <span v-if="shouldShowComma(index)">, </span>
    </span>
  </span>
</template>

<script>
  export default {
    props: {
      hideGroupName: Boolean,
      isInLastGroup: Boolean,
      selectedNames: Array,
    },

    name: 'GroupNameTags',

    methods: {
      shouldShowComma(index) {
        const isLastOfTags = index < (this.selectedNames.length - 1)
        if (this.hideGroupName) {
          return this.isInLastGroup ? isLastOfTags : true
        } else {
          return isLastOfTags
        }
      },
    },
  }
</script>